// eslint-disable-next-line
export async function fetchCandidate(from, to, next) {
  if (process.browser && !this.state.candidate.data) {
    await this.dispatch('candidate/fetchData', { vacancyId: from.params.vacancyId });
  }
  next();
}
